
export {} from '@clayui/empty-state';
import __x__ from '@clayui/empty-state';export default __x__;